// Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase,
// DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper,
// SplitText, CustomBounce, CustomWiggle,
import { gsap, ScrollTrigger, Flip } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, Flip);
// expose gsap

export default () => {
  let mm = gsap.matchMedia();

  if (document.querySelector('.page-template-template-postcode-checker')) {
    const input = document.querySelector('#postcode-input');
    const gemeentenList = document.querySelector('#gemeenten-list');
    const notFoundMessage = document.querySelector('#not-found-message');
    const postcodeInputValue = document.querySelector('#postcode-input-value');
    const fullResponse = document.querySelector('#full-response');
    const gemeenteName = document.querySelector('#gemeente-name');
    const message = document.querySelector('#message');

    // Configuration
    const searchDelay = 600; // Delay in milliseconds before search is triggered

    // Debounce timer for search input
    let searchTimeout = null;

    // Track if Flip has run at least once (skip animation on initial page load)
    let hasFilterStateChanged = false;

    // Function to update URL parameters with search query
    function updateURLParams(searchValue) {
      const url = new URL(window.location);

      if (searchValue && searchValue.trim()) {
        // Add or update the 'q' parameter (query)
        url.searchParams.set('q', searchValue.trim());
      } else {
        // Remove the parameter if search is empty
        url.searchParams.delete('q');
      }

      // Update URL without reloading the page
      // Using pushState to allow back button navigation
      window.history.pushState({}, '', url);
    }

    // Function to read URL parameters and populate input if present
    function readURLParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const queryParam = urlParams.get('q');

      if (queryParam && input) {
        input.value = queryParam;
        // Trigger search with the URL parameter value
        performSearch(queryParam);
      }
    }

    function getUniqueGemeenten(apiResponse) {
      const docs = apiResponse.response?.docs || [];
      const gemeentenMap = new Map();

      // Process each document
      docs.forEach(doc => {
        const gemeentenaam = doc.gemeentenaam;
        const score = doc.score;

        if (gemeentenaam) {
          // Keep the highest score for each municipality
          if (!gemeentenMap.has(gemeentenaam) || gemeentenMap.get(gemeentenaam).score < score) {
            gemeentenMap.set(gemeentenaam, {
              gemeentenaam: gemeentenaam,
              score: score,
              gemeentecode: doc.gemeentecode,
              provincienaam: doc.provincienaam
            });
          }
        }
      });

      // Convert to array and sort by score (highest first)
      return Array.from(gemeentenMap.values())
        .sort((a, b) => b.score - a.score);
    }

    // Function to filter gemeenten based on API results
    // Returns true if matches were found, false otherwise
    function filterGemeenten(uniqueGemeenten, searchValue) {
      const gemeentenList = document.querySelector('#gemeenten-list');
      const allGemeenteItems = Array.from(document.querySelectorAll('.gemeente-item'));
      let hasMatches = false;

      if (uniqueGemeenten.length === 0) {
        // No search results found, add hide class to all items
        allGemeenteItems.forEach(item => {
          item.classList.add('hide-filter-item');
        });
        return false; // No matches found
      }

      // Create a set of lowercase gemeente names from API results
      const apiGemeenten = new Set(
        uniqueGemeenten.map(g => g.gemeentenaam.toLowerCase())
      );

      // Normalize search value for comparison
      const normalizedSearch = searchValue.trim().toLowerCase();

      // Separate items into exact matches and other matches
      const exactMatches = [];
      const otherMatches = [];
      const noMatches = [];

      allGemeenteItems.forEach(item => {
        const gemeenteDataName = item.getAttribute('data-gemeente');

        if (apiGemeenten.has(gemeenteDataName)) {
          // Check if this is an exact match (case-insensitive)
          if (gemeenteDataName === normalizedSearch) {
            exactMatches.push(item);
          } else {
            otherMatches.push(item);
          }
          item.classList.remove('hide-filter-item');
          hasMatches = true;
        } else {
          // Item doesn't match search - add hide class
          item.classList.add('hide-filter-item');
          noMatches.push(item);
        }
      });

      // Reorder DOM: exact matches first, then other matches, then no matches
      // This ensures exact matches appear at the top
      const reorderedItems = [...exactMatches, ...otherMatches, ...noMatches];

      // Re-append items in the new order
      reorderedItems.forEach(item => {
        gemeentenList.appendChild(item);
      });

      // If no matches found, hide all items
      if (!hasMatches) {
        allGemeenteItems.forEach(item => {
          item.classList.add('hide-filter-item');
        });
      }

      return hasMatches;
    }

    // Function to reset all filters
    function resetFilters() {
      const allGemeenteItems = document.querySelectorAll('.gemeente-item');
      allGemeenteItems.forEach(item => {
        item.classList.remove('hide-filter-item');
      });
      postcodeInputValue.textContent = '';
    }

    // Function to perform the actual search
    async function performSearch(searchValue) {
      message.classList.remove('show');
      message.classList.remove('show-not-found');

      // Reset filters if input is empty
      if (!searchValue.trim()) {
        resetFilters();
        updateFilters();
        updateURLParams(''); // Clear URL parameter
        return;
      }


      const base = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q='
      let url
      if (/^\d{4}[A-Z]{2}$/i.test(searchValue)) {
        url = `${base}${searchValue}&fq=type:postcode`
      } else if (/^\d{4}$/.test(searchValue)) {
        url = `${base}${searchValue}&fq=type:postcode`
      } else {
        url = `${base}${searchValue}`
      }

      try {
        const res = await fetch(url);
        const data = await res.json();

        // Get unique municipalities
        const uniqueGemeenten = getUniqueGemeenten(data);

        // Filter the gemeenten list and get whether matches were found
        const hasMatches = filterGemeenten(uniqueGemeenten, searchValue);

        // Update the display and animations based on the classes
        updateFilters();

        // Update display elements based on whether matches were found
        if (hasMatches) {
          postcodeInputValue.textContent = uniqueGemeenten.map(g => `${g.gemeentenaam} (${g.provincienaam})`).join(', ');
        } else {
          // No matches found, show not found message
          gemeenteName.textContent = searchValue;
          message.classList.add('show');
          message.classList.add('show-not-found');
        }

        // Update URL with search query
        updateURLParams(searchValue);

        // Store full response for debugging (hidden)
        if (fullResponse) {
          fullResponse.textContent = JSON.stringify(data, null, 2);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
        postcodeInputValue.textContent = searchValue + ' (error)';
        resetFilters();
        updateFilters();
        // Still update URL even on error so user can share/search again
        updateURLParams(searchValue);
      }
    }

    input.addEventListener('input', () => {
      // Clear existing timeout
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      // Set new timeout for delayed search
      searchTimeout = setTimeout(() => {
        performSearch(input.value);
      }, searchDelay);
    });

    // Initialize with all gemeenten visible
    resetFilters();
    updateFilters();

    // Check for URL parameters on page load
    readURLParams();

    function updateFilters() {
      const state = Flip.getState(document.querySelectorAll('.filter-item')); // capture state before changes

      // Adjust the display property: "none" for items with hide-filter-item class, "block" for visible ones
      document.querySelectorAll('.filter-item').forEach(item => {
        if (item.classList.contains('hide-filter-item')) {
          item.style.display = 'none';
        } else {
          item.style.display = 'block';
        }
      });

      // Skip Flip animation on initial page load to avoid inline styles flash
      if (!hasFilterStateChanged) {
        hasFilterStateChanged = true;
        return;
      }

      // Animate from the previous state
      Flip.from(state, {
        duration: 1,
        scale: true,
        ease: "power1.inOut",
        stagger: 0.08,
        absolute: true,
        onEnter: elements => gsap.fromTo(elements, {
          opacity: 0,
          scale: 0
        }, {
          opacity: 1,
          scale: 1,
          duration: 1
        }),
        onLeave: elements => gsap.to(elements, {
          opacity: 0,
          scale: 0,
          duration: 1
        })
      });
    }
  }

  //--------------------------------//
  // getGeoLocation 
  //--------------------------------//
  function getGeoLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        console.log(position);
        // use base to get the gemeente name
        const base = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?'
        try {
          // fix Uncaught SyntaxError: Unexpected reserved word (at postcode-checker.js?t=1764166061369:227:23)
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          fetch(`${base}lat=${latitude}&lon=${longitude}`)
            .then(res => res.json())
            .then(data => {
              console.log(data);
              const gemeentenaam = data.response.docs[0].gemeentenaam;
              const postcodeInput = document.querySelector('#postcode-input');
              if (postcodeInput) {
                postcodeInput.value = gemeentenaam;
                postcodeInput.dispatchEvent(new Event('input'));
                // URL will be updated by the input event handler
              }
            })
            .catch(error => console.error('Error fetching data:', error));

        } catch (error) {
          console.error('Error fetching data:', error);
        }
      });
    }
  }
  if (document.querySelector('#get-geo-location')) {
    document.querySelector('#get-geo-location').addEventListener('click', getGeoLocation);
  }
};
